import React from "react";
import "./index.css";
import ParallaxImages from "./ParallaxImages";

function App() {
  return (
    <>
      <ParallaxImages />
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="300.000000pt"
        height="135.000000pt"
        viewBox="0 0 300.000000 135.000000"
        preserveAspectRatio="xMidYMid meet"
        className="mx-auto w-[80%] md:w-96 pt-4"
      >
        <metadata>
          Created by potrace 1.10, written by Peter Selinger 2001-2011
        </metadata>
        <g
          transform="translate(0.000000,135.000000) scale(0.050000,-0.050000)"
          fill="currentColor"
          stroke="none"
        >
          <path
            d="M680 2631 c-269 -58 -600 -314 -600 -464 0 -71 53 -57 107 28 90 143
328 303 526 355 540 141 421 -504 -179 -967 -104 -80 -188 -110 -167 -58 49
118 134 410 129 443 -10 73 -116 70 -116 -3 0 -57 -46 -200 -261 -813 -102
-293 -109 -345 -46 -366 12 -4 59 103 106 238 153 440 192 491 199 260 5 -151
143 -303 252 -276 24 6 79 61 121 122 41 60 77 110 79 110 2 0 -3 -43 -11 -95
-37 -244 120 -310 283 -118 l52 61 -39 -259 c-21 -142 -61 -361 -89 -486 -46
-208 -47 -230 -18 -259 60 -61 130 152 184 557 25 189 75 408 150 653 28 92
27 95 -32 113 -32 10 -62 -17 -155 -144 -226 -305 -272 -325 -225 -94 62 296
-60 294 -288 -4 -79 -103 -115 -107 -153 -16 -54 129 -39 245 36 284 174 89
522 504 591 705 111 319 -106 564 -436 493z"
          />
          <path
            d="M4134 2491 c-409 -146 -532 -424 -442 -1004 l13 -83 -188 -94 c-446
-224 -653 -432 -600 -607 164 -548 831 -208 860 437 8 201 18 219 108 220 64
0 67 -18 24 -143 -60 -178 6 -239 147 -135 l84 62 58 -62 c64 -68 85 -73 182
-39 54 19 75 17 123 -12 65 -38 140 -30 257 29 60 30 74 31 96 8 35 -38 102
-35 188 9 71 36 73 36 83 0 15 -60 82 -43 196 52 125 104 129 103 98 -26 -18
-75 -18 -110 -2 -142 24 -44 71 -36 53 10 -26 70 81 366 166 459 171 185 249
447 165 551 -64 80 -145 -45 -247 -381 -61 -202 -117 -287 -160 -244 -44 44
-93 25 -183 -68 -61 -64 -122 -104 -196 -129 -124 -42 -140 -36 -80 27 53 58
55 97 4 129 -44 27 -88 -2 -111 -76 -15 -47 -187 -139 -260 -139 l-52 0 61 65
c72 77 77 116 17 153 -46 29 -156 -59 -156 -126 0 -26 -52 -53 -155 -82 -36
-10 -45 -5 -45 28 0 64 -91 114 -160 88 -55 -21 -55 -20 -46 52 13 98 -43 149
-170 154 l-94 4 -15 97 c-32 201 -26 432 13 512 96 197 382 375 577 358 40 -3
50 -181 16 -298 -27 -95 64 -97 97 -2 92 264 -83 474 -324 388z m1600 -776
c-26 -58 -67 -127 -90 -155 l-43 -50 17 60 c26 92 86 234 121 289 l31 50 6
-45 c4 -24 -15 -91 -42 -149z m-2038 -570 c-29 -478 -584 -856 -694 -472 -30
105 64 238 280 398 81 60 385 229 412 229 6 0 7 -70 2 -155z"
          />
          <path
            d="M1556 1325 c-136 -142 -165 -243 -95 -332 58 -73 146 -71 217 5 53
57 54 57 100 20 65 -53 71 -51 203 74 117 112 117 112 99 46 -15 -50 -12 -77
11 -112 43 -66 57 -59 148 70 142 202 233 226 182 46 -22 -74 1 -142 47 -142
15 0 38 39 51 87 64 229 -84 350 -252 205 -45 -38 -60 -42 -76 -21 -58 75
-127 58 -246 -60 l-115 -113 -10 125 c-15 192 -134 237 -264 102z m164 -51 c0
-42 -114 -209 -159 -233 -75 -40 -38 76 60 187 66 75 99 90 99 46z"
          />
        </g>
      </svg>
    </>
  );
}

export default App;
